import { IRequestParams } from '@mihanizm56/fetch-api';
import { requestTranslateFunction } from '@/_constants/i18next/i18next-constants';
import { getAcceptanceCoefficientsReportEndpoint } from '@/api/endpoints/get-acceptance-coefficients-report';
import { DEFAULT_API_CACHE_PARAMS, STRATEGY } from '@/api/_constants';
import { getCacheKey } from '@/api/_utils/cache-utils';
import { responseSchema } from './response-schema';

export type TAcceptanceCoefficients = {
  dateFrom: string | Date;
  dateTo: string | Date;
  userID: number;
  supplierID: string;
};

export const makeRequestConfig = ({
  dateFrom,
  dateTo,
  userID,
  supplierID,
}: TAcceptanceCoefficients): IRequestParams => {
  const endpoint = getAcceptanceCoefficientsReportEndpoint();

  return {
    endpoint,
    responseSchema,
    body: {
      params: {
        dateTo,
        dateFrom,
      },
    },
    translateFunction: requestTranslateFunction,
    isErrorTextStraightToOutput: true,
    credentials: 'include',
    browserCacheParams: {
      ...DEFAULT_API_CACHE_PARAMS,
      strategy: STRATEGY.NetworkFirst,
      requestCacheKey: getCacheKey({
        endpoint,
        userID,
        supplierID,
        dateTo,
        dateFrom,
      }),
    },
  };
};
